import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/trucks-for-sale-in-uk-euro-6-and-leasing/")({
  head: () => routeHead("/trucks-for-sale-in-uk-euro-6-and-leasing/"),
  beforeLoad: () => {
    throw redirect({ href: "/uk/trucks", statusCode: 301, replace: true });
  },
});
